(() => {
  'use strict';

  /*
    PICCO + OMNISEND BACK IN STOCK - V23 DRAWER EDGE PADDING FIX

    This version intentionally uses NO product-page iframes.

    It uses one dedicated native Omnisend Back-in-Stock form across all Picco
    Quick Add drawer families, opens it with Omnisend's custom trigger, and
    docks the already-live Omnisend DOM into whichever drawer is active.
  */

  const QUICK_FORM_ID = '6aaf28240c62cd332a445c42';
  const EMBED_FORM_ID = '6a1d3ff15cab28beff904a2b';
  const PICCO_NOTIFY_EVENT = 'picco notify request';
  const SLOT_SELECTOR = '[data-picco-omnisend-bis-slot]';

  if (window.__PICCO_OMNISEND_BACKINSTOCK_V9__) return;
  window.__PICCO_OMNISEND_BACKINSTOCK_V9__ = true;

  const VARIANT_ROOT_SELECTOR = [
    '[data-quickshop-variants]',
    '[data-picco-options]',
    '[data-pc-variants]',
    '[data-quick-options]',
    '[data-picco-rvf-variants]',
    '[data-iwp-quick-options]',
    '[data-picco-cart-qa-options]'
  ].join(',');

  const QUICK_OPEN_SELECTOR = [
    '[data-open-quickshop]',
    '.picco-rf__quick-add',
    '[data-quick-add]',
    '[data-picco-rvf-quick-open]',
    '[data-iwp-quick-add]',
    '.picco-rec-add',
    'button[data-rec-handle]',
    '[data-pc-quick-add]',
    '[data-pc-open-quick]',
    'button[aria-label*="quick add" i]'
  ].join(',');

  const CLOSE_SELECTOR = [
    '[data-close-quickshop]',
    '[data-picco-close-drawer]',
    '[data-pc-close]',
    '[data-quick-close]',
    '[data-picco-rvf-quick-close]',
    '[data-iwp-quick-close]',
    '[data-picco-cart-qa-close]',
    '.picco-ref-quickshop__backdrop',
    '.picco-rf__drawer-underlay',
    '.pc-quick-add__backdrop'
  ].join(',');

  const SOLD_OUT_SELECTOR = [
    '[data-variant-option][data-available="false"]',
    '.picco-rf__variant-btn[data-available="false"]',
    '.pc-variant[data-available="false"]',
    '[data-pc-variants] [data-available="false"]',
    '.picco-quick-shop__variant-btn[data-available="false"]',
    '.picco-rvf__variant[data-available="false"]',
    '.picco-iwp__variant-btn[data-available="false"]',
    '.picco-cart-qa__variant[data-available="false"]',
    '[data-quickshop-variants] [data-available="false"]',
    '[data-picco-options] [data-available="false"]',
    '[data-quick-options] [data-available="false"]',
    '[data-picco-rvf-variants] [data-available="false"]',
    '[data-iwp-quick-options] [data-available="false"]',
    '[data-picco-cart-qa-options] [data-available="false"]'
  ].join(',');

  const productCache = new Map();
  const productPromises = new Map();
  let active = null;
  let selectionRevision = 0;
  let openingSession = null;
  let mutationTimer = 0;
  let suppressionTimer = 0;
  let suppressionPurgeTimers = [];

  function addStyles() {
    if (document.getElementById('PiccoOmnisendNativeQuickAddStyles')) return;

    const style = document.createElement('style');
    style.id = 'PiccoOmnisendNativeQuickAddStyles';
    style.textContent = `
      ${SLOT_SELECTOR} {
        display: block !important;
        position: relative;
        width: 100%;
        max-width: 100%;
        height: 0;
        min-height: 0;
        margin: 0;
        padding: 0;
        opacity: 0;
        overflow: hidden;
        pointer-events: none;
        box-sizing: border-box;
        transition:
          height 360ms cubic-bezier(.22, 1, .36, 1),
          opacity 220ms ease,
          margin-top 360ms cubic-bezier(.22, 1, .36, 1),
          margin-bottom 360ms cubic-bezier(.22, 1, .36, 1);
        will-change: height, opacity;
      }

      ${SLOT_SELECTOR}.is-active {
        opacity: 1;
        margin-top: 10px;
        margin-bottom: 0;
        padding-bottom: 0;
        pointer-events: auto;
        overflow: visible;
      }

      #omnisend-forms-container #omnisend-form-${QUICK_FORM_ID} {
        visibility: hidden !important;
        pointer-events: none !important;
      }

      ${SLOT_SELECTOR} .picco-bis-native-host {
        width: 100%;
        max-width: 100%;
        margin: 0;
        padding: 0;
        position: relative;
        box-sizing: border-box;
      }

      ${SLOT_SELECTOR} .picco-bis-native-host > * {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }

      html.picco-bis-native-open,
      body.picco-bis-native-open {
        overflow: auto !important;
        pointer-events: auto !important;
        touch-action: auto !important;
      }

      /* Omnisend still owns the live form logic, but its full-screen popup shell
         must never block the Quick Add drawer or the rest of the storefront. */
      body.picco-bis-native-open #omnisend-forms-container {
        position: static !important;
        inset: auto !important;
        width: 0 !important;
        height: 0 !important;
        min-width: 0 !important;
        min-height: 0 !important;
        overflow: visible !important;
        pointer-events: none !important;
        z-index: auto !important;
      }

      body.picco-bis-native-open [id*="omnisend-form-${QUICK_FORM_ID}"] {
        max-width: 100% !important;
      }

      body.picco-bis-native-open #omnisend-form-${QUICK_FORM_ID}-close-button,
      body.picco-bis-native-open [class*="omnisend-form-${QUICK_FORM_ID}"][class*="close-button"],
      ${SLOT_SELECTOR} #omnisend-form-${QUICK_FORM_ID}-close-button,
      ${SLOT_SELECTOR} [class*="omnisend-form-${QUICK_FORM_ID}"][class*="close-button"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      body.picco-bis-native-open .omnisend-form-${QUICK_FORM_ID}-overlay,
      body.picco-bis-native-open [class*="omnisend-form-${QUICK_FORM_ID}"][class*="overlay"],
      body.picco-bis-native-open [class*="omnisend-form-${QUICK_FORM_ID}"][class*="backdrop"],
      ${SLOT_SELECTOR} .omnisend-form-${QUICK_FORM_ID}-overlay,
      ${SLOT_SELECTOR} [class*="omnisend-form-${QUICK_FORM_ID}"][class*="overlay"],
      ${SLOT_SELECTOR} [class*="omnisend-form-${QUICK_FORM_ID}"][class*="backdrop"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      ${SLOT_SELECTOR} .omnisend-form-${QUICK_FORM_ID}-container,
      ${SLOT_SELECTOR} [class*="omnisend-form-${QUICK_FORM_ID}-container"] {
        position: static !important;
        inset: auto !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        transform: none !important;
        background: transparent !important;
        box-shadow: none !important;
        pointer-events: auto !important;
        z-index: auto !important;
      }

      ${SLOT_SELECTOR} .omnisend-form-${QUICK_FORM_ID}-content,
      ${SLOT_SELECTOR} .omnisend-form-${QUICK_FORM_ID}-content-inner {
        position: static !important;
        inset: auto !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        transform: none !important;
        pointer-events: auto !important;
      }

      /* ---------------------------------------------------------------
         REFERENCE OMNISEND DESIGN - CSS ONLY

         IMPORTANT: This section only changes CSS. It does not walk the form
         DOM, repeatedly write inline styles, add observers, or rebuild any
         Omnisend elements. That keeps the original working JS behaviour while
         matching the compact embedded reference design.
      ---------------------------------------------------------------- */

      ${SLOT_SELECTOR}.is-active {
        margin-top: 10px !important;
        margin-bottom: 14px !important;
        padding-bottom: 0 !important;
        overflow: visible !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #202020 !important;
        font: 400 10px/13.5px Helvetica, Arial, sans-serif !important;
        box-sizing: border-box !important;
      }

      /* Direct Omnisend form sections. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] > [class*="-section-"]:not([class*="-opacity-layer"]) {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: row wrap !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        position: relative !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] > [class*="-section-"]:not([class*="-opacity-layer"]) > .omnisend-mobile-container {
        display: flex !important;
        flex: 1 1 100% !important;
        flex-flow: column !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        position: relative !important;
        box-sizing: border-box !important;
      }

      /* TITLE */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] .omnisend-mobile-container > [class*="-text-"] {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 12px 12px 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
        position: static !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h1,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h2,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h3,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h4,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h5,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h6 {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #383838 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
        letter-spacing: .4px !important;
        text-transform: uppercase !important;
        box-sizing: border-box !important;
      }

      /* Omnisend sometimes wraps the heading copy in <strong>/<b>. Keep the
         heading visually regular to match the reference/store typography. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] .omnisend-mobile-container > [class*="-text-"] strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] .omnisend-mobile-container > [class*="-text-"] b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h1 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h2 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h3 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h4 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h5 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h6 strong,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h1 b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h2 b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h3 b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h4 b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h5 b,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] h6 b {
        font-weight: 400 !important;
      }

      /* EMAIL - underline only, 10px reference typography. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(input[type="email"]) {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: row !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(input[type="email"]) > [class*="-field-container-"] {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: column !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 0 12px !important;
        border: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] input[type="email"] {
        display: block !important;
        flex: 0 0 auto !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 26px !important;
        min-height: 26px !important;
        margin: 0 !important;
        padding: 5px 0 8px !important;
        border: 0 !important;
        border-bottom: 1px solid #dcdcd7 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        overflow: visible !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #202020 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
        letter-spacing: .4px !important;
        box-sizing: border-box !important;
      }

      /* PHONE - country prefix and number on one underlined row. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(input[type="tel"]) {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: row !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(input[type="tel"]) > [class*="-field-container-"] {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: column !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 0 12px !important;
        border: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-wrapper"]:has(input[type="tel"]) {
        display: flex !important;
        flex: 0 1 auto !important;
        flex-flow: row !important;
        align-items: center !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 38px !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 0 9px !important;
        border: 0 !important;
        border-bottom: 1px solid #dcdcd7 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        position: relative !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [role="combobox"] {
        display: flex !important;
        flex: 0 0 auto !important;
        flex-flow: row !important;
        align-items: center !important;
        width: auto !important;
        height: 11px !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 10px 0 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        color: #202020 !important;
        font: 400 10px/11px Helvetica, Arial, sans-serif !important;
        gap: 5px !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] input[type="tel"] {
        display: block !important;
        flex: 1 1 auto !important;
        width: auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 12px !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        outline: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: #202020 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
        letter-spacing: .4px !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] input::placeholder {
        color: #747470 !important;
        opacity: 1 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
        letter-spacing: .4px !important;
      }

      /* OPT-IN + PRIVACY COPY */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] > [class*="-section-"]:has(label[class*="-legal"]):not([class*="-opacity-layer"]) {
        padding: 0 0 2px 2px !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(label[class*="-legal"]) {
        display: flex !important;
        flex-flow: row !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-field-container-wrapper-"]:has(label[class*="-legal"]) > [class*="-field-container-"] {
        display: flex !important;
        flex-flow: column !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 0 12px !important;
        border: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] {
        display: flex !important;
        align-items: center !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 12px !important;
        min-height: 12px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #202020 !important;
        font: 400 7px/12px Helvetica, Arial, sans-serif !important;
        gap: 8px !important;
        position: relative !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"] {
        position: absolute !important;
        width: 2px !important;
        height: 2px !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: -1px !important;
        padding: 0 !important;
        opacity: 0 !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] div[class$="-input"] {
        display: block !important;
        flex: 0 0 8px !important;
        width: 8px !important;
        height: 8px !important;
        min-width: 8px !important;
        min-height: 8px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 1px solid #202020 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
        position: relative !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] div[class$="-label"] {
        display: block !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #202020 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
        text-transform: uppercase !important;
      }

      /* Keep the checkbox outline exactly the same when unchecked, then fill
         the visible square solid black when the hidden native checkbox is checked. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"]:checked + div[class$="-input"] {
        background: #202020 !important;
        border-color: #202020 !important;
        box-shadow: none !important;
      }

      /* Remove Omnisend's original tick and focus halo so only the custom square is visible. */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"] + div[class$="-input"]::after,
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"] ~ div[class$="-input"]::after {
        content: none !important;
        display: none !important;
        border: 0 !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"]:focus + div[class$="-input"],
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"]:focus ~ div[class$="-input"],
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"]:focus-visible + div[class$="-input"],
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] label[class*="-legal"] input[type="checkbox"]:focus-visible ~ div[class$="-input"] {
        outline: none !important;
        box-shadow: none !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-description-container"] {
        display: flex !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: #202020 !important;
        font: 400 7px Helvetica, Arial, sans-serif !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class$="-description"] {
        display: block !important;
        flex: 1 1 auto !important;
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        padding: 8px 0 0 !important;
        color: #383838 !important;
        font: 400 10px/12px Helvetica, Arial, sans-serif !important;
      }

      /* BUTTON */
      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] > [class*="-section-"]:has(button[type="submit"]):not([class*="-opacity-layer"]) {
        flex: 1 1 auto !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] [class*="-action-container-"]:has(> button[type="submit"]) {
        display: flex !important;
        flex-flow: column !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 0 16px !important;
        border: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} form[id^="omnisend-form-${QUICK_FORM_ID}"] button[type="submit"] {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: 44px !important;
        min-height: 44px !important;
        margin: 0 !important;
        padding: 0 16px !important;
        border: 1px solid #000 !important;
        border-radius: 0 !important;
        background: #000 !important;
        box-shadow: none !important;
        color: #fff !important;
        font: 500 10px/10px Helvetica, Arial, sans-serif !important;
        letter-spacing: .8px !important;
        text-transform: uppercase !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        position: relative !important;
        overflow: hidden !important;
      }

      /* ---------------------------------------------------------------
         NOTIFY ME SUBMIT LOADER

         Keep loading feedback inside the black button. Omnisend can inject
         its own form-level loader while the request is being submitted; hide
         that native loader only during submission and render one small circle
         in the button instead.
      ---------------------------------------------------------------- */
      @keyframes piccoBisButtonSpin {
        to { transform: rotate(360deg); }
      }

      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] {
        color: transparent !important;
        -webkit-text-fill-color: transparent !important;
        font-size: 0 !important;
        line-height: 0 !important;
        letter-spacing: 0 !important;
        text-shadow: none !important;
        pointer-events: none !important;
        cursor: wait !important;
      }

      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] * {
        opacity: 0 !important;
        visibility: hidden !important;
        color: transparent !important;
        -webkit-text-fill-color: transparent !important;
      }

      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"]::before {
        content: none !important;
        display: none !important;
      }

      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"]::after {
        content: "" !important;
        display: block !important;
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
        width: 14px !important;
        height: 14px !important;
        margin: -7px 0 0 -7px !important;
        padding: 0 !important;
        border: 1.5px solid rgba(255,255,255,.38) !important;
        border-top-color: #fff !important;
        border-radius: 50% !important;
        background: transparent !important;
        box-shadow: none !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: none !important;
        box-sizing: border-box !important;
        animation: piccoBisButtonSpin .65s linear infinite !important;
      }

      /* Remove Omnisend's own loader so it cannot cover the full inline form. */
      ${SLOT_SELECTOR} .picco-bis-submit-loading [class*="loading" i]:not(button),
      ${SLOT_SELECTOR} .picco-bis-submit-loading [class*="loader" i]:not(button),
      ${SLOT_SELECTOR} .picco-bis-submit-loading [class*="spinner" i]:not(button),
      ${SLOT_SELECTOR} .picco-bis-submit-loading [role="progressbar"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] [class*="loading" i],
      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] [class*="loader" i],
      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] [class*="spinner" i],
      ${SLOT_SELECTOR} .picco-bis-submit-loading button[type="submit"] [role="progressbar"] {
        display: none !important;
      }

      ${SLOT_SELECTOR},
      ${SLOT_SELECTOR} .picco-bis-native-host {
        padding-bottom: 0 !important;
      }

      /* Match the Notify Me form to the active drawer's real horizontal
         content inset. JS writes these values from the live Add to Bag /
         Sold Out control so every Quick Add drawer family stays aligned. */
      ${SLOT_SELECTOR} {
        padding-left: var(--picco-bis-edge-left, 0px) !important;
        padding-right: var(--picco-bis-edge-right, 0px) !important;
        box-sizing: border-box !important;
      }


      /* ---------------------------------------------------------------
         SUBMITTED / THANK-YOU STATE

         Omnisend keeps its success container in the DOM with display:none
         until a successful submission. Once that container becomes visible,
         hide the original input form completely and let only the success
         message occupy the inline slot. CSS only — no submit-state JS.
      ---------------------------------------------------------------- */
      ${SLOT_SELECTOR}:has(
        [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      ) {
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
      }

      ${SLOT_SELECTOR}
      [class*="-content-inner"]:has(
        > [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      )
      > form[id^="omnisend-form-${QUICK_FORM_ID}"] {
        position: absolute !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        overflow: hidden !important;
      }

      ${SLOT_SELECTOR}
      [class*="-content-inner"]:has(
        > [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      )
      > form[id^="omnisend-form-${QUICK_FORM_ID}"]
      > [class*="-section-"]:not([class*="-opacity-layer"]) {
        display: none !important;
      }

      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"]) {
        display: block !important;
        position: static !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 1 !important;
        visibility: visible !important;
        overflow: visible !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      > [class*="-section-"]:not([class*="-opacity-layer"]),
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      .omnisend-mobile-container {
        display: flex !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #383838 !important;
        font-family: Helvetica, Arial, sans-serif !important;
        font-size: 10px !important;
        line-height: 12px !important;
        font-weight: 400 !important;
        letter-spacing: .4px !important;
        text-transform: uppercase !important;
        box-sizing: border-box !important;
      }

      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h1,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h2,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h3,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h4,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h5,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] h6,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] p,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] li,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] span,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] strong,
      ${SLOT_SELECTOR} [class*="-success-sections-container"]:not([style*="display: none"]):not([style*="display:none"])
      [class*="-text-"] b {
        margin: 0 !important;
        padding: 0 !important;
        color: #383838 !important;
        font-family: Helvetica, Arial, sans-serif !important;
        font-size: 10px !important;
        line-height: 12px !important;
        font-weight: 400 !important;
        letter-spacing: .4px !important;
        text-transform: uppercase !important;
      }

      /* The drawer's SOLD OUT / ADD TO BAG control is replaced by the native
         NOTIFY ME control while the form is visible. */
      .picco-bis-drawer-action {
        overflow: hidden !important;
        opacity: 1;
        max-height: var(--picco-bis-action-height, 80px);
        transform: translateY(0);
        transition:
          opacity 170ms ease,
          max-height 300ms cubic-bezier(.22, 1, .36, 1),
          min-height 300ms cubic-bezier(.22, 1, .36, 1),
          padding 300ms cubic-bezier(.22, 1, .36, 1),
          margin 300ms cubic-bezier(.22, 1, .36, 1),
          border-width 300ms cubic-bezier(.22, 1, .36, 1),
          transform 240ms cubic-bezier(.22, 1, .36, 1) !important;
      }

      .picco-bis-drawer-action.is-picco-bis-replaced {
        opacity: 0 !important;
        max-height: 0 !important;
        min-height: 0 !important;
        height: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        border-top-width: 0 !important;
        border-bottom-width: 0 !important;
        transform: translateY(4px) !important;
        pointer-events: none !important;
      }

      ${SLOT_SELECTOR} .picco-bis-native-host {
        opacity: 0;
        transform: translateY(4px);
        transition:
          opacity 190ms ease,
          transform 260ms cubic-bezier(.22, 1, .36, 1);
      }

      ${SLOT_SELECTOR} .picco-bis-native-host.is-visible {
        opacity: 1;
        transform: translateY(0);
      }

      #PiccoBisNativeParking {
        position: fixed !important;
        left: -10000px !important;
        top: -10000px !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      /* Closing the inline drawer form must never allow Omnisend's popup shell
         to rebound onto the viewport while its own close handler is settling. */
      html.picco-bis-suppress-popup #omnisend-form-${QUICK_FORM_ID},
      body.picco-bis-suppress-popup #omnisend-form-${QUICK_FORM_ID},
      html.picco-bis-suppress-popup [id="omnisend-form-${QUICK_FORM_ID}"],
      body.picco-bis-suppress-popup [id="omnisend-form-${QUICK_FORM_ID}"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      [data-available="false"],
      .picco-bis-sold-out {
        pointer-events: auto !important;
        cursor: pointer !important;
      }

      @media (prefers-reduced-motion: reduce) {
        ${SLOT_SELECTOR} { transition: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function canonicalProductUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(String(value), location.origin);
      if (url.origin !== location.origin) return '';
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);
      if (!match) return '';
      return `${location.origin}/products/${match[1]}`;
    } catch (_) {
      return '';
    }
  }

  function productHandle(value) {
    try {
      return new URL(value, location.origin).pathname.match(/\/products\/([^/?#]+)/i)?.[1] || '';
    } catch (_) {
      return '';
    }
  }

  function exactVariantUrl(productUrl, variantId) {
    try {
      const url = new URL(productUrl, location.origin);
      url.search = '';
      url.hash = '';
      url.searchParams.set('variant', String(variantId));
      return url.href;
    } catch (_) {
      return productUrl;
    }
  }

  function urlFromNode(node) {
    if (!node) return '';
    const candidates = [
      node.dataset?.productUrl,
      node.getAttribute?.('href'),
      node.dataset?.handle ? `/products/${node.dataset.handle}` : '',
      node.dataset?.recHandle ? `/products/${node.dataset.recHandle}` : '',
      node.dataset?.piccoRvfQuickOpen ? `/products/${node.dataset.piccoRvfQuickOpen}` : '',
      node.closest?.('[data-product-url]')?.dataset?.productUrl,
      node.closest?.('a[href*="/products/"]')?.getAttribute?.('href'),
      node.closest?.('[data-rec-handle]')?.dataset?.recHandle
        ? `/products/${node.closest('[data-rec-handle]').dataset.recHandle}`
        : '',
      node.closest?.('[data-product-handle]')?.dataset?.productHandle
        ? `/products/${node.closest('[data-product-handle]').dataset.productHandle}`
        : ''
    ];
    for (const value of candidates) {
      const url = canonicalProductUrl(value);
      if (url) return url;
    }
    return '';
  }

  async function getProduct(productUrl) {
    const canonical = canonicalProductUrl(productUrl);
    if (!canonical) return null;
    if (productCache.has(canonical)) return productCache.get(canonical);
    if (productPromises.has(canonical)) return productPromises.get(canonical);

    const promise = (async () => {
      try {
        const response = await fetch(`${canonical}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('product-json-failed');
        const product = await response.json();
        productCache.set(canonical, product);
        return product;
      } catch (_) {
        return null;
      } finally {
        productPromises.delete(canonical);
      }
    })();

    productPromises.set(canonical, promise);
    return promise;
  }

  const NOTIFY_BUTTON_LABEL = 'Notify';
  const COMING_SOON_TITLE = 'Notify when product drops';

  function normalizedProductTags(product) {
    const tags = Array.isArray(product?.tags)
      ? product.tags
      : String(product?.tags || '').split(',');

    return tags
      .map(tag => String(tag || '').trim().toLowerCase())
      .filter(Boolean);
  }

  function productIsComingSoon(product) {
    return normalizedProductTags(product).some(tag =>
      tag === 'coming soon' ||
      tag === 'coming-soon' ||
      tag === 'comingsoon'
    );
  }

  function applyNotifyButtonLabel(control) {
    if (!control) return;

    if (control.matches?.('input[type="submit"]')) {
      if (control.value !== NOTIFY_BUTTON_LABEL) control.value = NOTIFY_BUTTON_LABEL;
    } else {
      const current = String(control.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (current !== NOTIFY_BUTTON_LABEL) control.textContent = NOTIFY_BUTTON_LABEL;
    }

    control.setAttribute?.('aria-label', NOTIFY_BUTTON_LABEL);
    control.dataset.piccoNotifyLabel = NOTIFY_BUTTON_LABEL;
  }

  function findNotifyTitleNodes(form) {
    if (!form) return [];

    const headings = Array.from(
      form.querySelectorAll('h1, h2, h3, h4, h5, h6')
    ).filter(node => {
      if (node.closest?.('[class*="-success-sections-container"]')) return false;
      if (node.closest?.('[class*="error" i], [role="alert"]')) return false;
      return true;
    });

    if (headings.length) return headings.slice(0, 1);

    const titleWrapper = form.querySelector(
      '.omnisend-mobile-container > [class*="-text-"]'
    );

    return titleWrapper ? [titleWrapper] : [];
  }

  function syncNotifyTitle(form, product) {
    if (!form || !product) return;

    const comingSoon = productIsComingSoon(product);

    findNotifyTitleNodes(form).forEach(node => {
      if (!node.dataset.piccoOriginalNotifyTitle) {
        node.dataset.piccoOriginalNotifyTitle = String(node.textContent || '').trim();
      }

      const originalTitle = node.dataset.piccoOriginalNotifyTitle || '';
      const desiredTitle = comingSoon ? COMING_SOON_TITLE : originalTitle;

      if (desiredTitle && String(node.textContent || '').trim() !== desiredTitle) {
        node.textContent = desiredTitle;
      }
    });
  }

  function syncSessionNotifyCopy(session) {
    if (!session?.form || !session?.product) return;
    if (session.submitting || session.didSubmitSuccessfully) return;

    session.form
      .querySelectorAll('button[type="submit"], input[type="submit"]')
      .forEach(applyNotifyButtonLabel);

    syncNotifyTitle(session.form, session.product);
  }

  function startProductPageNotifyCopySync() {
    const productUrl = canonicalProductUrl(location.href);
    if (!productUrl) return;

    getProduct(productUrl).then(product => {
      if (!product) return;

      let frame = 0;
      const sync = () => {
        frame = 0;

        document
          .querySelectorAll('.picco-omnisend-shell')
          .forEach(shell => {
            shell
              .querySelectorAll('button[type="submit"], input[type="submit"]')
              .forEach(applyNotifyButtonLabel);

            shell
              .querySelectorAll('form')
              .forEach(form => syncNotifyTitle(form, product));
          });
      };

      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(sync);
      };

      schedule();

      const observer = new MutationObserver(schedule);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });

      document.addEventListener('shopify:section:load', schedule);
    });
  }

  function productVariantById(product, variantId) {
    const id = String(variantId || '');
    if (!id) return null;
    return (product?.variants || []).find(variant => String(variant?.id || '') === id) || null;
  }

  function selectedVariantIdFromPage(product) {
    try {
      const fromUrl = new URL(location.href).searchParams.get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (_) {}

    const selectors = [
      'form[action*="/cart/add"] [name="id"]:checked',
      'form[action*="/cart/add"] select[name="id"]',
      'form[action*="/cart/add"] input[name="id"]',
      '[data-pcu-root] [name="id"]',
      '[data-product-form] [name="id"]'
    ];

    for (const selector of selectors) {
      const node = document.querySelector(selector);
      const value = node?.value || node?.getAttribute?.('value');
      if (value && productVariantById(product, value)) return String(value);
    }

    const onlyUnavailable = (product?.variants || []).filter(variant => variant?.available === false);
    if (onlyUnavailable.length === 1) return String(onlyUnavailable[0].id);

    return '';
  }

  function normalizeFormId(value) {
    return String(value || '')
      .replace(/^omnisend-form-/i, '')
      .trim();
  }

  function notifyRequestDedupeKey(email, product, variant) {
    return [
      'picco-notify-request-v1',
      String(email || '').trim().toLowerCase(),
      String(product?.id || ''),
      String(variant?.id || '')
    ].join(':');
  }

  function alreadyTrackedNotifyRequest(email, product, variant) {
    try {
      const key = notifyRequestDedupeKey(email, product, variant);
      if (sessionStorage.getItem(key) === '1') return true;
      sessionStorage.setItem(key, '1');
    } catch (_) {}
    return false;
  }

  function exactProductVariantUrl(productUrl, variantId) {
    try {
      const url = new URL(productUrl, location.origin);
      url.search = '';
      url.hash = '';
      if (variantId) url.searchParams.set('variant', String(variantId));
      return url.href;
    } catch (_) {
      return String(productUrl || location.href);
    }
  }

  function pushPiccoNotifyEvent(product, variant, formId, sourceContext) {
    if (!product || !variant) return;
    if (!window.omnisend || typeof window.omnisend.push !== 'function') return;

    const productUrl = canonicalProductUrl(product?.url || location.href) || canonicalProductUrl(location.href);
    const comingSoon = productIsComingSoon(product);

    window.omnisend.push([
      'track',
      PICCO_NOTIFY_EVENT,
      {
        origin: 'api',
        properties: {
          product_id: String(product?.id || ''),
          product_handle: String(product?.handle || productHandle(productUrl) || ''),
          product_title: String(product?.title || ''),
          variant_id: String(variant?.id || ''),
          variant_title: String(variant?.title || variant?.name || ''),
          sku: String(variant?.sku || ''),
          request_type: comingSoon ? 'coming_soon' : 'back_in_stock',
          is_coming_soon: !!comingSoon,
          page_url: exactProductVariantUrl(productUrl || location.href, variant?.id),
          source_form_id: String(formId || ''),
          source_context: String(sourceContext || '')
        }
      }
    ]);
  }

  async function trackPiccoNotifySubmission(detail) {
    const formId = normalizeFormId(detail?.form?.id || detail?.formId || '');
    if (formId !== QUICK_FORM_ID && formId !== EMBED_FORM_ID) return;

    const eventType = String(detail?.type || detail?.eventName || '').toLowerCase();
    if (eventType !== 'submit') return;

    const values = detail?.formValues || {};
    const email = String(values.emailField || values.email || '').trim();

    let product = null;
    let variantId = '';
    let sourceContext = 'product_page';
    let productUrl = canonicalProductUrl(location.href);

    if (formId === QUICK_FORM_ID && active?.product) {
      product = active.product;
      variantId = String(active?.detail?.variantId || '');
      productUrl = canonicalProductUrl(active?.detail?.productUrl || '') || productUrl;
      sourceContext = 'quick_add';
    } else {
      if (!productUrl) return;
      product = await getProduct(productUrl);
      variantId = selectedVariantIdFromPage(product);
    }

    if (!product) return;
    const variant = productVariantById(product, variantId);
    if (!variant) return;

    if (alreadyTrackedNotifyRequest(email, product, variant)) return;

    try {
      if (email && typeof window.omnisend?.identifyContact === 'function') {
        window.omnisend.identifyContact({ email });
      }
    } catch (_) {}

    setTimeout(() => {
      pushPiccoNotifyEvent(product, variant, formId, sourceContext);
    }, 120);
  }

  function bindPiccoNotifyDemandTracking() {
    if (window.__PICCO_NOTIFY_DEMAND_TRACKING_BOUND__) return;
    window.__PICCO_NOTIFY_DEMAND_TRACKING_BOUND__ = true;

    window.addEventListener('omnisendForms', event => {
      trackPiccoNotifySubmission(event?.detail || {});
    });
  }

  function prefetchProducts(scope = document) {
    const seen = new Set();
    scope.querySelectorAll?.('[data-product-url], [data-product-handle], a[href*="/products/"]').forEach(node => {
      const url = urlFromNode(node);
      if (!url || seen.has(url)) return;
      seen.add(url);
      getProduct(url);
    });
  }

  function slotFrom(node) {
    if (!node) return null;
    const root = node.closest?.(VARIANT_ROOT_SELECTOR) || node.querySelector?.(VARIANT_ROOT_SELECTOR);
    if (!root) return null;
    const area = root.parentElement;
    if (!area) return null;

    let slot = area.querySelector?.(`:scope > ${SLOT_SELECTOR}`) || area.querySelector?.(SLOT_SELECTOR);
    if (slot) return slot;

    slot = document.createElement('div');
    slot.className = 'picco-omnisend-bis-slot';
    slot.setAttribute('data-picco-omnisend-bis-slot', '');
    slot.hidden = true;

    const action = area.querySelector?.([
      '.picco-ref-quickshop__add-wrap',
      '.picco-rf__atc-wrap',
      '.pc-quick-add__action-row',
      '.picco-quick-shop__action-wrap',
      '.picco-rvf__quick-action-wrap',
      '.picco-iwp__quick-action-wrap',
      '.picco-cart-qa__action-wrap',
      '[data-quickshop-add]',
      '[data-picco-atc]',
      '[data-pc-add]',
      '[data-quick-submit]',
      '[data-picco-rvf-add]',
      '[data-iwp-add-to-bag]',
      '[data-picco-cart-qa-add]'
    ].join(','));

    if (action) {
      const wrap = action.matches?.('button') ? action.parentElement : action;
      wrap?.parentNode?.insertBefore(slot, wrap);
    } else {
      root.insertAdjacentElement('afterend', slot);
    }
    return slot;
  }

  function controlledDrawerFromOpener(opener) {
    if (!opener) return null;
    const id = opener.getAttribute?.('aria-controls');
    if (id) {
      const controlled = document.getElementById(id);
      if (controlled) return controlled;
    }
    return opener.closest?.('[data-quick-shop], [data-picco-rvf-quick], [data-iwp-quick-shell], [data-picco-cart-qa], [data-picco-drawer], [data-pc-quick-panel], [data-quickshop-product-content]') || null;
  }

  function rememberQuickProductContext(opener) {
    if (!opener) return '';
    const productUrl = urlFromNode(opener);
    if (!productUrl) return '';
    const drawer = controlledDrawerFromOpener(opener);
    if (drawer) {
      drawer.dataset.piccoBisProductUrl = productUrl;
      const title = opener.getAttribute?.('aria-label')?.replace(/^quick add\s*/i, '').trim() || '';
      if (title) drawer.dataset.piccoBisProductTitle = title;
      const existingSlot = drawer.querySelector?.(SLOT_SELECTOR);
      if (existingSlot) {
        existingSlot.dataset.productUrl = productUrl;
        delete existingSlot.dataset.variantId;
        if (title) existingSlot.dataset.productTitle = title;
      }
    }
    return productUrl;
  }

  function productContextFrom(node) {
    if (!node) return {};
    const container = node.closest?.([
      '[data-quickshop-product-content]',
      '[data-picco-drawer]',
      '[data-pc-quick-panel]',
      '[data-quick-shop]',
      '[data-picco-rvf-quick]',
      '[data-iwp-quick-shell]',
      '[data-picco-cart-qa]',
      '[data-product-card]',
      'article',
      'li'
    ].join(',')) || node.parentElement;

    const details = container?.querySelector?.([
      '[data-pc-product-link]',
      '[data-quick-details]',
      '[data-picco-rvf-details]',
      '[data-iwp-details]',
      '[data-picco-cart-qa-details]',
      '.picco-rf__view-details',
      '[data-product-link]',
      'a[href*="/products/"]'
    ].join(','));

    /* Shared quick-add drawers are reused for many products. Always prefer the
       drawer's CURRENT product context/details link over a slot value left by
       the previous product. */
    const slot = slotFrom(node);
    const productUrl = canonicalProductUrl(
      container?.dataset?.piccoBisProductUrl ||
      container?.dataset?.productUrl ||
      details?.getAttribute?.('href') ||
      node.dataset?.productUrl ||
      urlFromNode(node) ||
      slot?.dataset?.productUrl
    );

    const productTitle =
      container?.dataset?.piccoBisProductTitle ||
      container?.dataset?.productTitle ||
      container?.querySelector?.('[data-pc-title], [data-quick-title], [data-picco-rvf-quick-title], [data-iwp-quick-title], [data-picco-cart-qa-title], .picco-rf__drawer-title, .picco-ref-quickshop__name')?.textContent?.trim() ||
      node.dataset?.productTitle ||
      slot?.dataset?.productTitle || '';

    if (slot && productUrl) {
      slot.dataset.productUrl = productUrl;
      if (productTitle) slot.dataset.productTitle = productTitle;
    }

    return {
      productUrl,
      productTitle,
      productId: node.dataset?.productId || container?.dataset?.productId || slot?.dataset?.productId || '',
      slot
    };
  }

  function inferAvailable(control) {
    if (!control) return true;
    if (control.dataset?.available === 'true') return true;
    if (control.dataset?.available === 'false') return false;
    if (control.disabled || control.getAttribute?.('aria-disabled') === 'true') return false;
    const classes = `${control.className || ''} ${control.closest?.('label')?.className || ''}`.toLowerCase();
    return !/sold|unavailable|disabled|out[-_ ]?of[-_ ]?stock/.test(classes);
  }

  function controlFromEvent(target) {
    if (!target?.closest) return null;
    const root = target.closest(VARIANT_ROOT_SELECTOR);
    if (!root) return null;
    const control = target.closest('[data-available], [data-variant-id], [data-variant-option], input[type="radio"], button');
    return control && root.contains(control) ? control : null;
  }

  function detailFromControl(control) {
    const base = productContextFrom(control);
    const variantId = control.dataset?.variantId || control.getAttribute?.('data-id') || control.value || base.slot?.dataset?.variantId || '';
    return {
      ...base,
      variantId: String(variantId || ''),
      variantTitle:
        control.dataset?.variantTitle ||
        control.querySelector?.('.picco-rf__variant-name, .picco-quick-shop__variant-name, .picco-rvf__variant-name, .picco-iwp__variant-name, .picco-cart-qa__variant-name')?.textContent?.trim() ||
        control.closest?.('label')?.querySelector?.('.picco-ref-variant__label')?.textContent?.trim() ||
        control.getAttribute?.('aria-label')?.replace(/,\s*sold out/i, '') ||
        control.textContent?.trim() || '',
      available: inferAvailable(control),
      trigger: control
    };
  }

  const ACTION_SELECTOR = [
    '[data-quickshop-add]',
    '[data-picco-atc]',
    '[data-pc-add]',
    '[data-quick-submit]',
    '[data-picco-rvf-add]',
    '[data-iwp-add-to-bag]',
    '[data-picco-cart-qa-add]',
    '.picco-rf__atc',
    '.picco-quick-shop__atc',
    '.pc-quick-add__button'
  ].join(',');

  const ACTION_LABEL_SELECTOR = [
    '[data-quickshop-add-text]',
    '[data-picco-atc-text]',
    '[data-pc-add-text]',
    '[data-quick-add-label]',
    '[data-picco-rvf-add-label]',
    '[data-iwp-add-label]',
    '[data-picco-cart-qa-add-label]'
  ].join(',');

  function getActionButton(rootOrNode) {
    if (!rootOrNode) return null;
    const root = rootOrNode.closest?.(VARIANT_ROOT_SELECTOR) || rootOrNode.querySelector?.(VARIANT_ROOT_SELECTOR) || rootOrNode;
    const drawer = root?.closest?.([
      '[data-quickshop-product-content]',
      '[data-picco-drawer]',
      '[data-pc-quick-panel]',
      '[data-quick-shop]',
      '[data-picco-rvf-quick]',
      '[data-iwp-quick-shell]',
      '[data-picco-cart-qa]',
      '.picco-rf__drawer',
      '.picco-ref-quickshop',
      '.pc-quick-add__panel'
    ].join(','));
    return drawer?.querySelector?.(ACTION_SELECTOR) || root?.parentElement?.querySelector?.(ACTION_SELECTOR) || null;
  }

  function syncSlotHorizontalInset(slot, detailOrNode) {
    if (!slot) return;

    const source = detailOrNode?.trigger || detailOrNode || slot;
    const reference = getActionButton(source) || getActionButton(slot);
    if (!reference || !reference.isConnected) {
      slot.style.removeProperty('--picco-bis-edge-left');
      slot.style.removeProperty('--picco-bis-edge-right');
      return;
    }

    const slotRect = slot.getBoundingClientRect();
    const referenceRect = reference.getBoundingClientRect();
    if (!slotRect.width || !referenceRect.width) return;

    const left = Math.max(0, Math.round((referenceRect.left - slotRect.left) * 100) / 100);
    const right = Math.max(0, Math.round((slotRect.right - referenceRect.right) * 100) / 100);

    slot.style.setProperty('--picco-bis-edge-left', `${left}px`);
    slot.style.setProperty('--picco-bis-edge-right', `${right}px`);
  }

  function setActionState(control, available) {
    const root = control?.closest?.(VARIANT_ROOT_SELECTOR);
    if (!root) return;
    const add = getActionButton(root);
    const area = add?.parentElement || root.parentElement;
    const label = add?.querySelector?.(ACTION_LABEL_SELECTOR) || area?.querySelector?.(ACTION_LABEL_SELECTOR);
    if (add) {
      add.disabled = !available;
      add.setAttribute('aria-disabled', available ? 'false' : 'true');
    }
    if (label) label.textContent = available ? 'Add to bag' : 'Sold out';
  }

  function replaceDrawerAction(detail, slot) {
    const button = getActionButton(detail?.trigger || slot);
    if (!button) return null;
    if (button.__piccoBisActionTimer) {
      clearTimeout(button.__piccoBisActionTimer);
      button.__piccoBisActionTimer = 0;
    }
    const h = Math.max(1, button.getBoundingClientRect().height || button.offsetHeight || 44);
    button.style.setProperty('--picco-bis-action-height', `${h}px`);
    button.classList.add('picco-bis-drawer-action');
    if (button.__piccoBisActionFrame) cancelAnimationFrame(button.__piccoBisActionFrame);
    button.__piccoBisActionFrame = requestAnimationFrame(() => {
      button.__piccoBisActionFrame = 0;
      if (active?.visible && active.actionButton === button) button.classList.add('is-picco-bis-replaced');
    });
    return button;
  }

  function restoreDrawerAction(button, immediate = false) {
    if (!button) return;
    if (button.__piccoBisActionFrame) cancelAnimationFrame(button.__piccoBisActionFrame);
    button.__piccoBisActionFrame = 0;
    if (button.__piccoBisActionTimer) clearTimeout(button.__piccoBisActionTimer);
    button.__piccoBisActionTimer = 0;
    button.classList.remove('is-picco-bis-replaced');
    const clean = () => {
      button.classList.remove('picco-bis-drawer-action');
      button.style.removeProperty('--picco-bis-action-height');
      button.__piccoBisActionTimer = 0;
    };
    if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) clean();
    else button.__piccoBisActionTimer = setTimeout(clean, 320);
  }

  function selectSoldOutVisually(control) {
    if (!control) return;
    const root = control.closest?.(VARIANT_ROOT_SELECTOR);
    if (!root) return;

    control.dataset.available = 'false';
    control.disabled = false;
    control.classList.add('picco-bis-sold-out');

    if (control.matches('input[type="radio"]')) {
      control.checked = true;
      root.querySelectorAll('input[type="radio"]').forEach(input => {
        if (input !== control) input.checked = false;
      });
    } else {
      control.classList.add('is-selected');
      control.setAttribute('aria-checked', 'true');
      root.querySelectorAll('[role="radio"], button[data-available], button[data-variant-id]').forEach(other => {
        if (other === control) return;
        other.classList.remove('is-selected');
        if (other.hasAttribute('aria-checked')) other.setAttribute('aria-checked', 'false');
      });
    }
    setActionState(control, false);
  }

  function prepareSoldOutControls(scope = document) {
    scope.querySelectorAll?.(SOLD_OUT_SELECTOR).forEach(control => {
      control.dataset.available = 'false';
      /* Native disabled blocks click events completely. aria-disabled does not,
         so keep aria-disabled for the section's visual state but remove only the
         actual disabled property when present. */
      if (control.disabled) control.disabled = false;
      control.classList.add('picco-bis-sold-out');
    });
  }

  function prepareQuickOpeners(scope = document) {
    scope.querySelectorAll?.(`${QUICK_OPEN_SELECTOR}[disabled]`).forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    });
  }

  function snapshotContext() {
    return {
      url: location.href,
      historyState: history.state,
      shopifyMeta: window.ShopifyAnalytics?.meta ? JSON.parse(JSON.stringify(window.ShopifyAnalytics.meta)) : null
    };
  }

  function productMeta(product) {
    return {
      id: product.id,
      gid: `gid://shopify/Product/${product.id}`,
      vendor: product.vendor || '',
      type: product.type || '',
      handle: product.handle || '',
      variants: (product.variants || []).map(v => ({
        id: v.id,
        price: Number(v.price || 0),
        name: `${product.title || ''}${v.title ? ` - ${v.title}` : ''}`,
        public_title: v.title || null,
        sku: v.sku || null
      })),
      remote: false
    };
  }

  function installVirtualProductContext(product, productUrl, variantId) {
    const previous = snapshotContext();
    const exactUrl = exactVariantUrl(productUrl, variantId);

    try { history.replaceState(history.state, '', exactUrl); } catch (_) {}

    window.ShopifyAnalytics = window.ShopifyAnalytics || {};
    window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
    window.ShopifyAnalytics.meta.currency = window.ShopifyAnalytics.meta.currency || window.Shopify?.currency?.active || 'AUD';
    window.ShopifyAnalytics.meta.product = productMeta(product);
    window.ShopifyAnalytics.meta.page = {
      ...(window.ShopifyAnalytics.meta.page || {}),
      pageType: 'product',
      resourceType: 'product',
      resourceId: product.id
    };

    return previous;
  }

  function restoreVirtualContext(previous) {
    if (!previous) return;
    try { history.replaceState(previous.historyState, '', previous.url); } catch (_) {}
    if (previous.shopifyMeta) {
      window.ShopifyAnalytics = window.ShopifyAnalytics || {};
      window.ShopifyAnalytics.meta = previous.shopifyMeta;
    }
  }

  function ensureOmnisendQueue() {
    window.omnisend = window.omnisend || [];
    return window.omnisend;
  }

  function nativeNodes() {
    const formsContainer = document.getElementById('omnisend-forms-container');
    const form = document.querySelector(`form[id^="omnisend-form-${QUICK_FORM_ID}"]`);
    const exactRoot = document.getElementById(`omnisend-form-${QUICK_FORM_ID}`);
    const idNode = document.querySelector(`[id*="${QUICK_FORM_ID}"]`);

    let root = exactRoot || form?.parentElement || idNode || null;
    if (root && formsContainer) {
      let current = root;
      while (current.parentElement && current.parentElement !== formsContainer && current.parentElement !== document.body) {
        if (current.parentElement.id === 'omnisend-forms-wrapper') break;
        current = current.parentElement;
      }
      if (current !== formsContainer && current.id !== 'omnisend-forms-wrapper') root = current;
    }

    return { formsContainer, form, root };
  }

  function waitForNativeForm(timeout = 7000) {
    return new Promise(resolve => {
      const existing = nativeNodes();
      if (existing.form && existing.root) return resolve(existing);

      const started = performance.now();
      const observer = new MutationObserver(() => {
        const bits = nativeNodes();
        if (bits.form && bits.root) {
          observer.disconnect();
          resolve(bits);
        } else if (performance.now() - started > timeout) {
          observer.disconnect();
          resolve(null);
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style','class','hidden'] });

      const timer = setInterval(() => {
        const bits = nativeNodes();
        if (bits.form && bits.root) {
          clearInterval(timer);
          observer.disconnect();
          resolve(bits);
        } else if (performance.now() - started > timeout) {
          clearInterval(timer);
          observer.disconnect();
          resolve(null);
        }
      }, 60);
    });
  }

  function snapshotStyle(node) {
    return node ? node.getAttribute('style') : null;
  }

  function restoreStyle(node, value) {
    if (!node) return;
    if (node.getAttribute('style') === (value ?? null)) return;
    if (value === null || value === undefined) node.removeAttribute('style');
    else node.setAttribute('style', value);
  }

  function snapshotPageStyles() {
    return {
      htmlStyle: snapshotStyle(document.documentElement),
      bodyStyle: snapshotStyle(document.body)
    };
  }

  function restorePageStyles(snapshot) {
    if (!snapshot) return;
    restoreStyle(document.documentElement, snapshot.htmlStyle);
    restoreStyle(document.body, snapshot.bodyStyle);
  }

  function modalParts(root) {
    if (!root) return {};
    return {
      dialog: root.querySelector(`.omnisend-form-${QUICK_FORM_ID}-container, [class*="omnisend-form-${QUICK_FORM_ID}-container"]`),
      closeButton: root.querySelector(`#omnisend-form-${QUICK_FORM_ID}-close-button, [class*="omnisend-form-${QUICK_FORM_ID}"][class*="close-button"]`),
      overlay: root.querySelector(`.omnisend-form-${QUICK_FORM_ID}-overlay, [class*="omnisend-form-${QUICK_FORM_ID}"][class*="overlay"], [class*="omnisend-form-${QUICK_FORM_ID}"][class*="backdrop"]`)
    };
  }

  function neutralizeModalShell(root, formsContainer) {
    const { dialog, closeButton, overlay } = modalParts(root);

    if (formsContainer) {
      formsContainer.style.setProperty('position', 'static', 'important');
      formsContainer.style.setProperty('inset', 'auto', 'important');
      formsContainer.style.setProperty('width', '0', 'important');
      formsContainer.style.setProperty('height', '0', 'important');
      formsContainer.style.setProperty('min-width', '0', 'important');
      formsContainer.style.setProperty('min-height', '0', 'important');
      formsContainer.style.setProperty('overflow', 'visible', 'important');
      formsContainer.style.setProperty('pointer-events', 'none', 'important');
      formsContainer.style.setProperty('z-index', 'auto', 'important');
    }

    if (dialog) {
      dialog.setAttribute('role', 'group');
      dialog.removeAttribute('aria-modal');
      dialog.style.setProperty('position', 'static', 'important');
      dialog.style.setProperty('inset', 'auto', 'important');
      dialog.style.setProperty('width', '100%', 'important');
      dialog.style.setProperty('max-width', '100%', 'important');
      dialog.style.setProperty('height', 'auto', 'important');
      dialog.style.setProperty('min-height', '0', 'important');
      dialog.style.setProperty('max-height', 'none', 'important');
      dialog.style.setProperty('margin', '0', 'important');
      dialog.style.setProperty('padding', '0', 'important');
      dialog.style.setProperty('transform', 'none', 'important');
      dialog.style.setProperty('background', 'transparent', 'important');
      dialog.style.setProperty('box-shadow', 'none', 'important');
      dialog.style.setProperty('pointer-events', 'auto', 'important');
      dialog.style.setProperty('z-index', 'auto', 'important');
    }

    if (closeButton) {
      closeButton.style.setProperty('display', 'none', 'important');
      closeButton.style.setProperty('visibility', 'hidden', 'important');
      closeButton.style.setProperty('opacity', '0', 'important');
      closeButton.style.setProperty('pointer-events', 'none', 'important');
    }

    if (overlay) {
      overlay.style.setProperty('display', 'none', 'important');
      overlay.style.setProperty('visibility', 'hidden', 'important');
      overlay.style.setProperty('opacity', '0', 'important');
      overlay.style.setProperty('pointer-events', 'none', 'important');
    }

    return { dialog, closeButton, overlay };
  }

  function measuredHeight(node) {
    if (!node) return 0;
    try {
      const rect = node.getBoundingClientRect();
      return Math.max(Math.ceil(rect.height || 0), Math.ceil(node.scrollHeight || 0), Math.ceil(node.offsetHeight || 0));
    } catch (_) { return 0; }
  }

  function syncSlotHeight() {
    if (!active?.visible || !active?.slot || !active?.host) return;

    /* Do not use the full Omnisend root height here. Omnisend can keep an
       invisible modal/footer reserve below the submit button, which creates
       the large blank gap in the Quick Add drawer. The visible inline form
       should end exactly at the bottom of the Notify Me button. */
    const submit = active.form?.querySelector?.('button[type="submit"], input[type="submit"]');
    let h = 0;

    if (submit) {
      try {
        const hostRect = active.host.getBoundingClientRect();
        const submitRect = submit.getBoundingClientRect();
        h = Math.ceil(submitRect.bottom - hostRect.top);
      } catch (_) {}
    }

    if (!h || h < 1) h = Math.max(1, measuredHeight(active.form));
    active.slot.style.height = `${h}px`;
  }

  function getParkingHost() {
    let parking = document.getElementById('PiccoBisNativeParking');
    if (!parking) {
      parking = document.createElement('div');
      parking.id = 'PiccoBisNativeParking';
      parking.setAttribute('aria-hidden', 'true');
      document.body.appendChild(parking);
    }
    return parking;
  }

  function disconnectSessionObservers(session) {
    try { session?.resizeObserver?.disconnect(); } catch (_) {}
    try { session?.mutationObserver?.disconnect(); } catch (_) {}
    session.resizeObserver = null;
    session.mutationObserver = null;
    for (const timer of session?.releaseTimers || []) clearTimeout(timer);
    if (session) session.releaseTimers = [];
  }

  function styleMountedRoot(session) {
    const { root, form, formsContainer } = session;
    root.style.setProperty('display', 'block', 'important');
    root.style.setProperty('position', 'static', 'important');
    root.style.setProperty('inset', 'auto', 'important');
    root.style.setProperty('transform', 'none', 'important');
    root.style.setProperty('width', '100%', 'important');
    root.style.setProperty('max-width', '100%', 'important');
    root.style.setProperty('height', 'auto', 'important');
    root.style.setProperty('max-height', 'none', 'important');
    root.style.setProperty('margin', '0', 'important');
    root.style.setProperty('padding', '0', 'important');
    root.style.setProperty('opacity', '1', 'important');
    root.style.setProperty('visibility', 'visible', 'important');
    root.style.setProperty('pointer-events', 'auto', 'important');
    root.style.setProperty('z-index', '1', 'important');
    root.style.setProperty('background', 'transparent', 'important');
    root.style.setProperty('box-shadow', 'none', 'important');

    form.style.setProperty('display', 'block', 'important');
    form.style.setProperty('width', '100%', 'important');
    form.style.setProperty('max-width', '100%', 'important');
    form.style.setProperty('height', 'auto', 'important');
    form.style.setProperty('margin', '0', 'important');
    form.style.setProperty('padding', '0', 'important');
    form.style.setProperty('border', '0', 'important');
    form.style.setProperty('border-radius', '0', 'important');
    form.style.setProperty('background', 'transparent', 'important');
    form.style.setProperty('box-shadow', 'none', 'important');
    form.style.setProperty('font-family', 'Helvetica, Arial, sans-serif', 'important');

    syncSessionNotifyCopy(session);

    const neutralized = neutralizeModalShell(root, formsContainer);
    session.dialog = neutralized.dialog;
    session.closeButton = neutralized.closeButton;
    session.overlay = neutralized.overlay;
  }

  function nodeIsVisible(node) {
    if (!node || !document.documentElement.contains(node)) return false;
    try {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    } catch (_) {
      return false;
    }
  }

  function hasVisibleSubmitSuccess(session) {
    if (!session?.root) return false;
    return Array.from(session.root.querySelectorAll('[class*="-success-sections-container"], [class*="success" i]'))
      .some(node => nodeIsVisible(node));
  }

  function hasVisibleSubmitResult(session) {
    if (!session?.root) return false;
    if (hasVisibleSubmitSuccess(session)) return true;

    return Array.from(session.root.querySelectorAll('[class*="error" i], [role="alert"]'))
      .some(node => nodeIsVisible(node));
  }

  function setSubmitLoading(session, loading) {
    if (!session?.root || !session?.form) return;

    clearTimeout(session.submitLoadingTimer);
    session.submitLoadingTimer = 0;
    session.submitting = !!loading;

    session.root.classList.toggle('picco-bis-submit-loading', !!loading);
    session.form.classList.toggle('picco-bis-is-submitting', !!loading);

    const button = session.form.querySelector('button[type="submit"], input[type="submit"]');
    if (button) {
      if (loading) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }

    if (loading) {
      /* Safety release only. Normal completion is detected immediately by the
         mutation observer when Omnisend shows success or validation feedback. */
      session.submitLoadingTimer = setTimeout(() => {
        if (session.submitting) setSubmitLoading(session, false);
      }, 15000);
    }
  }

  function syncSubmitLoadingState(session) {
    if (!session) return;

    if (hasVisibleSubmitSuccess(session)) {
      session.didSubmitSuccessfully = true;
    }

    if (!session.submitting) return;
    if (!session.visible || hasVisibleSubmitResult(session)) setSubmitLoading(session, false);
  }

  function ensureSubmitContextGuard(session) {
    if (!session?.form || session.submitGuardInstalled) return;
    const refresh = () => {
      if (!session.visible || !session.product || !session.detail) return;
      restoreVirtualContext(session.previousContext);
      session.previousContext = installVirtualProductContext(
        session.product,
        session.detail.productUrl,
        session.detail.variantId
      );
    };

    session.form.addEventListener('submit', () => {
      refresh();
      setSubmitLoading(session, true);
    }, true);

    session.form.addEventListener('pointerdown', event => {
      if (event.target?.closest?.('button[type="submit"], input[type="submit"]')) refresh();
    }, true);
    session.form.addEventListener('click', event => {
      if (event.target?.closest?.('button[type="submit"], input[type="submit"]')) refresh();
    }, true);
    session.submitGuardInstalled = true;
  }

  function bindSessionObservers(session) {
    disconnectSessionObservers(session);

    try {
      session.resizeObserver = new ResizeObserver(() => {
        if (active === session && session.visible) {
          syncSlotHorizontalInset(session.slot, session.detail);
          syncSlotHeight();
        }
      });
      session.resizeObserver.observe(session.root);
      session.resizeObserver.observe(session.form);
      if (session.slot?.parentElement) session.resizeObserver.observe(session.slot.parentElement);
      if (session.actionButton) session.resizeObserver.observe(session.actionButton);
    } catch (_) {}

    try {
      const options = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style','class','hidden','aria-hidden']
      };
      session.mutationObserver = new MutationObserver(() => {
        if (active !== session || !session.visible) return;
        const observer = session.mutationObserver;
        observer.disconnect();
        try {
          styleMountedRoot(session);
          syncSubmitLoadingState(session);
          syncSessionNotifyCopy(session);
          syncSlotHorizontalInset(session.slot, session.detail);
          syncSlotHeight();
        } finally {
          if (active === session && session.visible && session.mutationObserver === observer) observer.observe(session.root, options);
        }
      });
      session.mutationObserver.observe(session.root, options);
    } catch (_) {}
  }

  function mountSessionInSlot(session, slot, detail, product, previousContext, pageStyles) {
    if (!session?.root || !session?.form || !slot) return false;

    disconnectSessionObservers(session);
    session.previousContext = previousContext;
    session.detail = detail;
    session.product = product;
    session.pageStyles = pageStyles;
    session.slot = slot;
    session.visible = true;

    const host = document.createElement('div');
    host.className = 'picco-bis-native-host';
    slot.replaceChildren(host);
    host.appendChild(session.root);
    session.host = host;

    document.documentElement.classList.add('picco-bis-native-open');
    document.body.classList.add('picco-bis-native-open');
    restorePageStyles(pageStyles);
    styleMountedRoot(session);
    restorePageStyles(pageStyles);

    slot.hidden = false;
    syncSlotHorizontalInset(slot, detail);
    slot.classList.add('is-active');
    slot.dataset.bisState = 'ready';
    slot.dataset.variantId = String(detail.variantId || '');
    slot.dataset.productUrl = String(detail.productUrl || '');
    if (detail.productId) slot.dataset.productId = String(detail.productId);
    if (detail.productTitle) slot.dataset.productTitle = detail.productTitle;

    session.actionButton = replaceDrawerAction(detail, slot);
    syncSessionNotifyCopy(session);
    ensureSubmitContextGuard(session);
    bindSessionObservers(session);

    requestAnimationFrame(() => {
      if (active !== session || !session.visible || session.host !== host) return;
      syncSlotHeight();
      requestAnimationFrame(() => {
        if (active !== session || !session.visible || session.host !== host) return;
        syncSlotHeight();
        if (active === session && session.visible) host.classList.add('is-visible');
      });
    });

    [0, 60, 180, 420].forEach(ms => {
      const timer = setTimeout(() => {
        if (active !== session || !session.visible || session.host !== host) return;
        styleMountedRoot(session);
        restorePageStyles(pageStyles);
        syncSlotHeight();
      }, ms);
      session.releaseTimers.push(timer);
    });

    return true;
  }

  function dockNativeForm(bits, slot, detail, product, previousContext, pageStyles) {
    if (!bits?.root || !bits?.form || !slot) return false;

    const root = bits.root;
    const parts = modalParts(root);
    const session = {
      slot: null,
      host: null,
      root,
      form: bits.form,
      previousContext: null,
      detail: null,
      product: null,
      pageStyles: null,
      formsContainer: bits.formsContainer,
      dialog: parts.dialog,
      closeButton: parts.closeButton,
      overlay: parts.overlay,
      originalStyles: {
        formsContainer: pageStyles?.formsContainerStyle ?? snapshotStyle(bits.formsContainer)
      },
      releaseTimers: [],
      resizeObserver: null,
      mutationObserver: null,
      actionButton: null,
      visible: false,
      submitting: false,
      submitLoadingTimer: 0,
      submitGuardInstalled: false,
      didSubmitSuccessfully: false
    };

    active = session;
    return mountSessionInSlot(session, slot, detail, product, previousContext, pageStyles);
  }

  function quickFormRootNodes() {
    return Array.from(document.querySelectorAll(`#omnisend-form-${QUICK_FORM_ID}`));
  }

  function purgeQuickFormOutsideDrawer() {
    for (const node of quickFormRootNodes()) {
      if (active?.root === node) continue;
      if (node.closest?.(SLOT_SELECTOR)) continue;
      try { node.remove(); } catch (_) {}
    }
  }

  function clearSuppressionTimers() {
    clearTimeout(suppressionTimer);
    suppressionTimer = 0;
    for (const timer of suppressionPurgeTimers) clearTimeout(timer);
    suppressionPurgeTimers = [];
  }

  function releasePopupSuppression() {
    clearSuppressionTimers();
    document.documentElement.classList.remove('picco-bis-suppress-popup');
    document.body?.classList.remove('picco-bis-suppress-popup');
  }

  function suppressPopupRebound(duration = 1400) {
    clearSuppressionTimers();
    document.documentElement.classList.add('picco-bis-suppress-popup');
    document.body?.classList.add('picco-bis-suppress-popup');

    /* Omnisend can repaint its popup DOM a few frames after the close click.
       Purge only this dedicated Quick Add form, never any other Omnisend form. */
    [0, 40, 120, 280, 650, 1100].forEach(ms => {
      suppressionPurgeTimers.push(setTimeout(purgeQuickFormOutsideDrawer, ms));
    });

    suppressionTimer = setTimeout(() => {
      purgeQuickFormOutsideDrawer();
      document.documentElement.classList.remove('picco-bis-suppress-popup');
      document.body?.classList.remove('picco-bis-suppress-popup');
      suppressionTimer = 0;
      suppressionPurgeTimers = [];
    }, duration);
  }

  function clearSlot(slot) {
    if (!slot) return;
    slot.classList.remove('is-active');
    slot.style.height = '0px';
    slot.removeAttribute('data-bis-state');
    slot.removeAttribute('data-variant-id');
    slot.removeAttribute('data-product-id');
    slot.removeAttribute('data-product-url');
    slot.removeAttribute('data-product-title');
    slot.style.removeProperty('--picco-bis-edge-left');
    slot.style.removeProperty('--picco-bis-edge-right');
  }

  function hideActive(immediate = false) {
    selectionRevision++;
    if (openingSession) {
      restoreVirtualContext(openingSession.previousContext);
      openingSession.previousContext = null;
      restorePageStyles(openingSession.pageStyles);
    }
    if (!active || !active.visible) return;

    const current = active;
    current.visible = false;
    setSubmitLoading(current, false);
    disconnectSessionObservers(current);

    current.host?.classList.remove('is-visible');
    restoreDrawerAction(current.actionButton, immediate);
    current.actionButton = null;

    clearSlot(current.slot);
    restoreVirtualContext(current.previousContext);
    current.previousContext = null;

    /* The form itself has already been moved out of Omnisend's modal tree, so
       restoring the page/container immediately cannot create a popup rebound.
       It also makes an instant re-open snapshot the real drawer/page state. */
    restoreStyle(current.formsContainer, current.originalStyles?.formsContainer);
    restorePageStyles(current.pageStyles);

    const finish = () => {
      /* A new sold-out size may have reopened the same live form before this
         collapse animation completed. In that case the old close must die. */
      if (current.visible) return;
      const parking = getParkingHost();

      try {
        current.root.style.setProperty('display', 'none', 'important');
        current.root.style.setProperty('visibility', 'hidden', 'important');
        current.root.style.setProperty('opacity', '0', 'important');
        current.root.style.setProperty('pointer-events', 'none', 'important');
        parking.appendChild(current.root);
      } catch (_) {}

      try { current.host?.remove(); } catch (_) {}
      if (current.slot) {
        current.slot.hidden = true;
        current.slot.style.height = '0px';
        try { current.slot.replaceChildren(); } catch (_) {}
      }

      document.documentElement.classList.remove('picco-bis-native-open');
      document.body.classList.remove('picco-bis-native-open');
      restoreStyle(current.formsContainer, current.originalStyles?.formsContainer);
      restorePageStyles(current.pageStyles);

      current.host = parking;
      current.slot = null;
      current.pageStyles = null;
    };

    if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else setTimeout(finish, 380);
  }

  function resetSubmittedStateForNewTarget(session) {
    if (!session?.root) return true;
    setSubmitLoading(session, false);

    /* Once Omnisend reaches its success state, its internal component state is
       also submitted. Merely hiding the success DOM does not make that same form
       safely reusable. Tell the caller to create a fresh Omnisend instance. */
    if (session.didSubmitSuccessfully || hasVisibleSubmitSuccess(session)) {
      session.didSubmitSuccessfully = true;
      return false;
    }

    return true;
  }

  async function discardSubmittedSession(session) {
    if (!session) return;

    session.visible = false;
    setSubmitLoading(session, false);
    disconnectSessionObservers(session);

    session.host?.classList.remove('is-visible');
    restoreDrawerAction(session.actionButton, true);
    session.actionButton = null;

    clearSlot(session.slot);
    restoreVirtualContext(session.previousContext);
    session.previousContext = null;

    restoreStyle(session.formsContainer, session.originalStyles?.formsContainer);
    restorePageStyles(session.pageStyles);

    /* Let Omnisend receive its own native close action so its private submitted
       state is released before we ask openForm for a brand-new instance. */
    try { session.closeButton?.click(); } catch (_) {}

    try { session.root?.remove(); } catch (_) {}
    try { session.host?.remove(); } catch (_) {}

    if (session.slot) {
      session.slot.hidden = true;
      session.slot.style.height = '0px';
      try { session.slot.replaceChildren(); } catch (_) {}
    }

    document.documentElement.classList.remove('picco-bis-native-open');
    document.body.classList.remove('picco-bis-native-open');

    session.host = null;
    session.slot = null;
    session.pageStyles = null;

    if (active === session) active = null;

    /* Omnisend's close handler can finish on the next task. A short yield avoids
       openForm seeing the just-submitted instance as still active. */
    await new Promise(resolve => setTimeout(resolve, 60));
  }

  async function showSoldOut(detail = {}) {
    releasePopupSuppression();

    const productUrl = canonicalProductUrl(detail.productUrl || detail.slot?.dataset?.productUrl || urlFromNode(detail.trigger));
    const variantId = String(detail.variantId || detail.slot?.dataset?.variantId || '');
    const slot = detail.slot || slotFrom(detail.trigger);
    if (!productUrl || !variantId || !slot) return;
    const revision = ++selectionRevision;
    const isCurrent = () => revision === selectionRevision && slot.isConnected;

    slot.dataset.productUrl = productUrl;
    slot.dataset.variantId = variantId;
    if (detail.productTitle) slot.dataset.productTitle = detail.productTitle;
    if (detail.productId) slot.dataset.productId = detail.productId;

    const product = await getProduct(productUrl);
    if (!isCurrent()) return;
    if (!product) {
      slot.dataset.bisState = 'unavailable';
      return;
    }

    const selected = (product.variants || []).find(v => String(v.id) === variantId);
    if (selected?.available === true) {
      clearSlot(slot);
      return;
    }

    const normalizedDetail = {
      ...detail,
      productUrl,
      variantId,
      productId: detail.productId || product.id
    };

    const targetChanged = !!(active?.detail && (
      String(active.detail.variantId || '') !== variantId ||
      canonicalProductUrl(active.detail.productUrl || '') !== productUrl
    ));

    if (active && (targetChanged || (!active.visible && active.didSubmitSuccessfully))) {
      const canReuse = resetSubmittedStateForNewTarget(active);
      if (!canReuse) {
        await discardSubmittedSession(active);
        if (!isCurrent()) return;
      }
    }

    /* Reuse the live form only while it is still a genuine pre-submit instance.
       A successfully submitted form is rebuilt above so Omnisend gives the next
       product/variant a fresh working Notify Me button. */
    if (active?.root && active?.form && document.documentElement.contains(active.form)) {
      if (active.visible && active.slot === slot) {
        if (String(active.detail?.variantId) === variantId && active.detail?.productUrl === productUrl) return;

        installVirtualProductContext(product, productUrl, variantId);
        active.detail = normalizedDetail;
        active.product = product;
        syncSessionNotifyCopy(active);
        slot.dataset.bisState = 'ready';
        slot.dataset.variantId = variantId;
        slot.dataset.productUrl = productUrl;
        if (normalizedDetail.productId) slot.dataset.productId = String(normalizedDetail.productId);
        if (normalizedDetail.productTitle) slot.dataset.productTitle = normalizedDetail.productTitle;
        styleMountedRoot(active);
        syncSlotHeight();
        return;
      }

      if (active.visible) {
        hideActive(true);
        selectionRevision = revision;
      }

      const pageStyles = snapshotPageStyles();
      pageStyles.formsContainerStyle = snapshotStyle(document.getElementById('omnisend-forms-container'));
      const previousContext = installVirtualProductContext(product, productUrl, variantId);
      mountSessionInSlot(active, slot, normalizedDetail, product, previousContext, pageStyles);
      return;
    }

    /* First sold-out selection only: ask Omnisend to create the native form. */
    slot.dataset.bisState = 'opening';
    let opening = openingSession;
    if (!opening) {
      purgeQuickFormOutsideDrawer();
      const pageStyles = snapshotPageStyles();
      pageStyles.formsContainerStyle = snapshotStyle(document.getElementById('omnisend-forms-container'));
      opening = {
        pageStyles,
        previousContext: installVirtualProductContext(product, productUrl, variantId),
        promise: null,
        mounted: false,
        releaseTimers: []
      };
      openingSession = opening;
      try {
        ensureOmnisendQueue().push(['openForm', QUICK_FORM_ID]);
        [0, 30, 90, 180].forEach(ms => {
          opening.releaseTimers.push(setTimeout(() => {
            if (openingSession !== opening || !opening.previousContext) return;
            neutralizeModalShell(null, nativeNodes().formsContainer);
            restorePageStyles(opening.pageStyles);
          }, ms));
        });
        opening.promise = waitForNativeForm(7000);
      } catch (_) {
        opening.promise = Promise.resolve(null);
      }
    } else {
      if (!opening.previousContext) {
        opening.pageStyles = snapshotPageStyles();
        opening.pageStyles.formsContainerStyle = snapshotStyle(document.getElementById('omnisend-forms-container'));
        opening.previousContext = installVirtualProductContext(product, productUrl, variantId);
      } else installVirtualProductContext(product, productUrl, variantId);
    }

    const bits = await opening.promise;
    if (!isCurrent()) {
      setTimeout(() => {
        if (openingSession !== opening || opening.mounted) return;
        if (!opening.previousContext && bits?.root) {
          bits.root.style.setProperty('display', 'none', 'important');
          bits.root.style.setProperty('visibility', 'hidden', 'important');
          bits.root.style.setProperty('pointer-events', 'none', 'important');
          getParkingHost().appendChild(bits.root);
        }
      }, 0);
      return;
    }
    openingSession = null;
    opening.releaseTimers.forEach(timer => clearTimeout(timer));
    const { previousContext, pageStyles } = opening;
    installVirtualProductContext(product, productUrl, variantId);
    if (!bits?.form || !bits?.root) {
      restoreVirtualContext(previousContext);
      restorePageStyles(pageStyles);
      restoreStyle(document.getElementById('omnisend-forms-container'), pageStyles.formsContainerStyle);
      slot.dataset.bisState = 'unavailable';
      return;
    }

    opening.mounted = true;
    if (!dockNativeForm(bits, slot, normalizedDetail, product, previousContext, pageStyles)) {
      restoreVirtualContext(previousContext);
      restorePageStyles(pageStyles);
      restoreStyle(document.getElementById('omnisend-forms-container'), pageStyles.formsContainerStyle);
      slot.dataset.bisState = 'unavailable';
    }
  }

  function update(detail = {}) {
    const available = detail.available === true || detail.available === 'true';
    if (available) {
      if (!detail.slot || active?.slot === detail.slot || !active?.visible) hideActive(false);
      return;
    }
    showSoldOut(detail);
  }

  function bindEvents() {
    ['pointerover','pointerdown'].forEach(type => {
      document.addEventListener(type, event => {
        const opener = event.target?.closest?.(QUICK_OPEN_SELECTOR);
        const url = opener ? rememberQuickProductContext(opener) || urlFromNode(opener) : '';
        if (url) getProduct(url);
      }, true);
    });

    document.addEventListener('click', event => {
      const opener = event.target?.closest?.(QUICK_OPEN_SELECTOR);
      if (opener) {
        const url = rememberQuickProductContext(opener);
        if (url) getProduct(url);
      }

      const closer = event.target?.closest?.(CLOSE_SELECTOR);
      if (closer) {
        hideActive(true);
        return;
      }

      const control = controlFromEvent(event.target);
      if (!control) return;
      const detail = detailFromControl(control);
      if (!detail.available) {
        /* Smart Grid and Cart intentionally ignore unavailable variants in their
           own button handlers. Capture the sold-out click here and stop it before
           those handlers discard it; this click belongs to Back In Stock. */
        event.preventDefault();
        event.stopPropagation();
        selectSoldOutVisually(control);
        try { control.focus({ preventScroll:true }); } catch (_) {}
        update({ ...detail, available:false });
        return;
      }

      setActionState(control, true);
      if (!detail.slot || active?.slot === detail.slot) setTimeout(() => hideActive(false), 0);
    }, true);

    document.addEventListener('change', event => {
      const control = controlFromEvent(event.target);
      if (control) update(detailFromControl(control));
    }, true);

    document.addEventListener('picco:variant:selection', event => {
      const raw = event.detail || {};
      update({
        ...raw,
        productUrl: canonicalProductUrl(raw.productUrl || raw.slot?.dataset?.productUrl || urlFromNode(raw.trigger)),
        variantId: String(raw.variantId || raw.slot?.dataset?.variantId || ''),
        slot: raw.slot || slotFrom(raw.trigger),
        trigger: raw.trigger || null
      });
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') hideActive(false);
    }, true);

    window.addEventListener('resize', () => {
      if (active?.visible) syncSlotHeight();
    }, { passive:true });
  }

  function setupMutationObserver() {
    const observer = new MutationObserver(mutations => {
      if (!mutations.some(m => m.addedNodes?.length)) return;

      if (document.documentElement.classList.contains('picco-bis-suppress-popup')) {
        purgeQuickFormOutsideDrawer();
      }

      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => {
        prepareSoldOutControls(document);
        prepareQuickOpeners(document);
        prefetchProducts(document);
      }, 60);
    });
    observer.observe(document.documentElement, { childList:true, subtree:true });
  }

  function initialise() {
    addStyles();
    prepareSoldOutControls(document);
    prepareQuickOpeners(document);
    prefetchProducts(document);
    startProductPageNotifyCopySync();
    bindPiccoNotifyDemandTracking();
    bindEvents();
    setupMutationObserver();
    [150,500,1200,2500].forEach(ms => setTimeout(() => prefetchProducts(document), ms));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once:true });
  else initialise();

  window.PiccoOmnisendBackInStock = {
    version:'25.0.0-stable-notify-selection',
    formId:QUICK_FORM_ID,
    refresh(){ prepareSoldOutControls(document); prepareQuickOpeners(document); prefetchProducts(document); },
    update,
    hide:hideActive,
    status(){
      return {
        version:'25.0.0-stable-notify-selection',
        formId:QUICK_FORM_ID,
        active:!!active,
        visible:!!active?.visible,
        activeProduct:active?.detail?.productUrl || null,
        activeVariant:active?.detail?.variantId || null,
        cachedProducts:productCache.size
      };
    }
  };
})();
